import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
// import { Router, ActivatedRoute, Params } from "@angular/router";
import {FlashMessagesService} from 'angular2-flash-messages';

import 'rxjs/add/operator/toPromise';

import {URL_API} from './../constante';
import {HEADERS} from './../constante';
import {MAX_TAM_ARQ} from './../constante';
import {Utils} from '../shared/utils';
import {Inscricao} from './inscricao';


@Injectable()
export class InscricaoService {
    options: RequestOptions;
    headers:any;

    private url_api = URL_API + '/inscricao';

    save(inscricao: any, update: string): Promise<Response> {
		let tamanho: number = 0;
		for (let campo in inscricao) 
			if (inscricao[campo] instanceof File) {
				tamanho += inscricao[campo].size;
				if (!(this.testarTipo(inscricao[campo].type))) {
					this.utils.exibirMensagem('Os arquivos precisam ser um PDF ou uma imagem!', 'warning');
					return null;
				}
				inscricao['tamanho_' + campo] = inscricao[campo].size;
			}		
		if (tamanho > MAX_TAM_ARQ) {
			this.utils.exibirMensagem('O tamanho dos arquivos têm que ser menor do que 10 Mb.', 'danger');
			return null;
		}
		
		return this.http
            .post(this.url_api + update, this.utils.buildFormData(inscricao))
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    getInscricao(id: number): Promise<Inscricao> {
        let url: string = this.url_api + '/' + id;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json() as Inscricao)
            .catch((error) => this.utils.handleError(error));
    }


    getInscricoes(user_id: number): Promise<Inscricao[]> {
        let url: string = this.url_api + '/user/' + user_id;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json() as Inscricao[])
            .catch((error) => this.utils.handleError(error));
    }

    delInsc(inscricao: any): Promise<Response> {
        // inscricao=JSON.stringify(inscricao);
        //console.log(inscricao);
        let url: string = this.url_api + '/delete';
        return this.http
            .post(url, inscricao, {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

	getTodasInscricoes(): Promise<Inscricao[]> {
        return this.http.get(this.url_api + '/list')
            .toPromise()
            .then(response => response.json() as Inscricao[])
            .catch((error) => this.utils.handleError(error));
    }
	
    constructor(private http: Http,
                private flashMessagesService: FlashMessagesService,
				private utils: Utils) {
		this.utils = utils;
        this.headers = HEADERS;
        this.options = new RequestOptions({ headers: this.headers });
    }
	
	testarTipo(tipo: string): boolean {
		return tipo.indexOf('pdf') > 0 || tipo.indexOf('image') == 0; 
	}
}


// WEBPACK FOOTER //
// ./src/app/inscricao/inscricao.service.ts